// @flow
import Select from './Select'
import { createFormGroup } from '@src/components/ui/FormGroup'

export default createFormGroup(Select)
